import React, { useContext, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';

import Constants, { appConfig } from '../../config.js'
import { UserContext } from "../../Contexts/UserContext/UserContext.js";

// .module.css prevents affecting other .js files
import "../../resources/css/select_wallet.module.css"
import { getLog } from '../../helpers/helpers.js';
import HoverSelector from '../../components/HoverSelector.js';
import { ButtonPrimaryOutlined } from '../../components/Buttons.js';


const invisibleLinkStyle = {
    textDecoration: "none",
    cursor: "pointer",
    color: "white",
}

const useStyles = makeStyles({
    invisibleLink: {
        ...invisibleLinkStyle,
        '&:hover': {
            ...invisibleLinkStyle,
        },
    },
});


export default function Select_Wallet(props) {
    const classname = "Select_Wallet: "
    const function_id = classname
    const log = getLog(function_id)

    const classes = useStyles();

    // import { useTheme } from '@mui/material';
    // const theme = useTheme(); // Access the theme directly
    // const primaryColor = theme.palette.primary.main

    const userContext = useContext(UserContext)

    async function onMountedComponent() {
        await userContext.reset_wallet()
        log("reset_wallet successful")
    }
    useEffect(() => {
        onMountedComponent()
    }, []); // equivalent to componentDidMount()

    return (
        <div className="Select_Wallet">
            <div className="mode-selection-style">

                <div className="mode-list">
                    <NavLink to="/create_new_wallet" className={classes.invisibleLink}>
                        <HoverSelector
                            iconClass="fa fa-plus-square"
                            title={Constants.CREATE_NEW_WALLET}
                            description={Constants.CREATE_WALLET_INFO}
                        />
                    </NavLink>

                    {/*
                    <NavLink to="/new_wallet_from_hardware" className={classes.invisibleLink}> 
                        <HoverSelector
                            iconClass="fa fa-upload"
                            title={"(currently unavailable)"+Constants.CREATE_WALLET_HARDWARE}
                            description={Constants.CREATE_WALLET_HARDWARE_INFO}
                        />
                    </NavLink>
                    */}

                    <NavLink to="/restore_wallet_from_file" className={classes.invisibleLink}>
                        <HoverSelector
                            iconClass="fa fa-folder-open"
                            title={Constants.RESTORE_FROM_FILE}
                            description={Constants.RESTORE_FROM_FILE_INFO}
                        />
                    </NavLink>

                    <NavLink to="/restore_wallet" className={classes.invisibleLink}>
                        <HoverSelector
                            iconClass="fa fa-server"
                            title={Constants.RESTORE_WALLET_SEED}
                            description={Constants.RESTORE_SEED_INFO}
                        />
                    </NavLink>
                </div>

                <div className="return-button">
                    <NavLink className="return-logo" to="/">
                        <ButtonPrimaryOutlined>
                            Back
                        </ButtonPrimaryOutlined>
                    </NavLink>
                </div>

                {/* make it easier to scroll if needed */}
                <div style={{ height: "40vh" }}>&nbsp;</div>

            </div>
        </div>
    );
}
